import EventManager from '../eventManager/EventManager'
import { writeCss } from '../helpers/DOM'
import { Slot } from '../slots/Slot'

const GROW_LOCKED_SELECTOR = '[class*=grow-exclusive-content-widget]'
const GROW_SCRIPT_ID = 'growExclusive'

const lockedContentCSS = `
  body ${GROW_LOCKED_SELECTOR} .adunitwrapper {
    visibility: hidden;
    display: none;
  }
  body ${GROW_LOCKED_SELECTOR} mv-ad-reporter {
    visibility: hidden;
    display: none;
  }
`

export class GrowExclusive {
  private static blockedAdUnits: Set<Slot> = new Set()
  private static blockEnabled: boolean = false

  public static slotIsBlocked(slot: Slot): boolean {
    return GrowExclusive.blockEnabled && GrowExclusive.blockedAdUnits.has(slot)
  }
  public static userLoggedIn(): void {
    GrowExclusive.blockEnabled = false

    const exclusiveScript = document.querySelector(`#${GROW_SCRIPT_ID}`)
    exclusiveScript && exclusiveScript.remove()
  }

  constructor() {
    GrowExclusive.blockEnabled = true
    writeCss(lockedContentCSS, GROW_SCRIPT_ID)

    EventManager.on(EventManager.events.slotWrapperRenderEnded, (slot) => {
      if (slot.wrapper.matches(`${GROW_LOCKED_SELECTOR} div`)) {
        GrowExclusive.blockedAdUnits.add(slot)
      }
    })
  }
}
